import { render, staticRenderFns } from "./VmSecgroup.vue?vue&type=template&id=7edf481a"
import script from "./VmSecgroup.vue?vue&type=script&lang=js"
export * from "./VmSecgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports